import React from "react";
import { withNamespaces } from "react-i18next";
import { Card, Avatar, Typography, CardContent } from "@mui/material";
import DefaultAvatar from "~/assets/img/avatar/avatar-default.png";

const ColaboratorCard = ({ person, index, isMobile, t }) => {
  return (
    <Card
      key={index}
      sx={{
        marginBottom: "1rem",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        display: "flex",
        padding: "1rem",
        flexDirection: isMobile ? "column" : "row", // Adjust layout for mobile
        alignItems: isMobile ? "center" : "flex-start",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: isMobile ? "center" : "flex-start", // Center image for mobile
          justifyContent: isMobile ? "center" : "flex-start", // Center image for mobile
          flexDirection: isMobile ? "column" : "row", // Adjust layout for mobile
          flex: 1,
          width: "100%", // Ensure div occupies full width
        }}
      >
        <Avatar
          aria-label="colaborator-avatar"
          variant="square"
          src={person.foto ? person.foto : DefaultAvatar}
          sx={{
            width: "100px",
            height: "auto",
            marginRight: isMobile ? "0" : "1rem", // Remove margin for mobile
            marginBottom: isMobile ? "1rem" : "0", // Add margin below for mobile
            objectFit: "contain",
          }}
        />
        <div
          style={{
            textAlign: "left", // Align text to the left
            width: "100%", // Ensure div occupies full width
          }}
        >
          <Typography variant="body2">
            <strong>{t("NewColaboratorsWidget.nome")}:</strong>{" "}
            {person.nome || "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>{t("NewColaboratorsWidget.funcao")}:</strong>{" "}
            {person.funcao || "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>{t("NewColaboratorsWidget.team")}:</strong>{" "}
            {person.departamento || "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>{t("NewColaboratorsWidget.work_location")}:</strong>{" "}
            {person.localTrabalho || "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>{t("NewColaboratorsWidget.admisson_date")}:</strong>{" "}
            {person.data_admissao
              ? new Date(person.data_admissao).toLocaleDateString("pt-PT")
              : "N/A"}
          </Typography>
        </div>
      </div>
      <CardContent
        sx={{
          flex: 1,
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
          padding: "1rem",
          marginTop: isMobile ? "1rem" : "0", // Add margin on top for mobile
          width: "100%", // Ensure CardContent occupies full width
        }}
      >
        <Typography variant="body2">
          <strong>{t("NewColaboratorsWidget.personal_apresentation")}:</strong>
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {person.textoApresentacao || "N/A"}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default withNamespaces()(ColaboratorCard);